// src/features/medicalSercices/page/serviceTypeForm.tsx

import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import DynamicForm, { type DynamicFormSchema } from '@/common/components/DynamicForm/DynamicForm';

export default function ServiceTypeForm() {
const serviceTypeFormSchema: DynamicFormSchema = {
  layout: 'vertical', // Overall form layout
 // submitButtonText: 'Save User', // Custom text for the submit button
  showResetButton: true, // Show a reset button

  // Define form sections for better organization and complex layouts
  sections: [
    {
      key: 'ServiceType-details', // Unique key for the section
      title: 'Service Type Form', // Title displayed if type is 'card'
      type: 'card', // This section will be rendered inside an Ant Design Card
      layout: { type: 'grid', gutter: 24 }, // Fields within this section use a 2-column grid with 24px gutter
      fields: [
       
        {
          name: 'name',
          label: 'Name',
          type: 'input',
          required: true,
          requiredMessage: 'Please enter a name.', // Custom required message
          autocomplete: 'false',
              pattern: 'AlphaNumericWithSpaceHyphenApostropheAmpersandCommaDotSlashBrackets',
              validation: [
                  { min: 3, message: 'Name must be at least 3 characters long.' },
                  { max: 100, message: 'Name cannot be more than 100 characters long.' },
              ],
          colSpan: 24, // Takes 12 out of 24 grid units (half width)
        },
         {
             name: 'nameAr',
          label: 'Name (Arabic)',
          type: 'input',
          required: true,
          requiredMessage: 'Please enter a name in arabic.', // Custom required message
             autocomplete: 'false',
             pattern: 'AlphabetsWithSpaceAr',
             validation: [
                 { min: 3, message: 'Name must be at least 3 characters long.' },
                 { max: 100, message: 'Name cannot be more than 100 characters long.' },
             ],
          colSpan: 24, // Takes 12 out of 24 grid units (half width)
        },
        {
            name: 'isActive',
            label: 'Status',
            type: 'switch',
            colSpan: 12, // Full width
        },
      ],
    },
   
  ],
};

  return (
    <DynamicForm
          schema={serviceTypeFormSchema}
          submitApiUrl={API_ENDPOINTS.INSURANCEPLAN.SAVE_SERVICETYPE}
          getByIdApiUrl={API_ENDPOINTS.INSURANCEPLAN.GET_SERVICETYPE_BY_ID}
          updateApiUrl={API_ENDPOINTS.INSURANCEPLAN.UPDATE_SERVICETYPE}
          refreshTableDataKey={QUERY_KEYS.INSURANCEPLAN.SERVICETYPES} 
    />
  );
}
